import "./ClientPortalPreview.module.css";
import Header from "@/reusable_sections/Header";
import DashboardPreviewHero from "./sections/DashboardPreviewHero";
import ClientPortalPreview from "./sections/ClientPortalPreview";
import RateShoppingParityMonitoring from "./sections/RateShoppingParityMonitoring";
import ClientPortalFeatures from "./sections/ClientPortalFeatures";
import Footer from "@/reusable_sections/Footer";
export default function ClientPortalPreviewPage() {
  return <div>
      <Header />
      <DashboardPreviewHero />
      <ClientPortalPreview />
      <RateShoppingParityMonitoring />
      <ClientPortalFeatures />
      <Footer />
    </div>;
}